import React, { useState, useEffect } from 'react';
import DeviceDependentSettingForm from './DeviceDependentSettingForm';
import { withStyles, CircularProgress, Dialog } from '@material-ui/core';
import History from "../../../History";
import { Paper } from '@material-ui/core';
import { connect } from 'react-redux';
import * as actions from './store/deviceDependentSettingActions';
import { parseURL } from '../../sc-utilities';
import { snackActions } from '../../sc-utilities/SnackBar';
import { BackButton, hasPermission } from '../../sc-utilities';
import * as Yup from "yup";
import { CancelToken } from 'axios';
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const searchParams = () => {
    return parseURL(window.location.href);
}

const DeviceDependentSettingsEdit = props => {
    const { classes, dependentSetting, clearForm, loadDependentSettings, permissions, onEditDeviceDependentSettings, activeCustomerID, translations } = props;
    const [settingNumber, setSettingNumber] = useState({ settingNumber: [], initialValues: {}, data: true })

    const handleSubmit = async data => {
        let objToSend = {}
        let dataToSend = {}
        for (var key in data) {
            if (key.includes('Key')) {
                let number = key.split('_')[1];
                if (settingNumber.settingNumber.includes(Number(number))) {
                    dataToSend[data[key]] = data[`Value_${number}`];
                }
                if (data[key] === '') {
                    return snackActions.snackBar({
                        message: 'Key cannot be empty!',
                        options: {
                            variant: 'warning'
                        }
                    });
                }
            }
        }
        objToSend['DependentType'] = data['DependentType'];
        objToSend['DependentSettings'] = JSON.stringify(dataToSend);
        objToSend['id'] = searchParams() ? searchParams().id : null;
        let result = await onEditDeviceDependentSettings({ ...objToSend, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            if (dependentSetting) {
                let object = JSON.parse(dependentSetting.DependentSetting);
                let array = [];
                let obj = { DependentType: dependentSetting && dependentSetting.DependentType ? dependentSetting.DependentType : '' };
                if (object) {
                    for (let i = 0; i < Object.keys(object).length; i++) {
                        array.push(i);
                        obj[`Key_${i}`] = Object.keys(object)[i];
                        obj[`Value_${i}`] = Object.values(object)[i];
                    }
                    setSettingNumber({ settingNumber: array, initialValues: obj, data: false });
                }
            }
        }
        fetchData();
        return () => {
            clearForm();
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dependentSetting]);

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            if (!dependentSetting) {
                await loadDependentSettings({ id: searchParams() ? searchParams().id : null, ActiveCustomerID: activeCustomerID });
            }
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let formSettings = {
        Validation: {
            DependentType: Yup.string().required("Required"),
        },
        FormTitle: translations['edit_dependent_setting'] || 'Edit dependent settings',
        ButtonSubmit: hasPermission(permissions, "device_dependent_setting_edit") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog
                disableBackdropClick={true}
                disableEscapeKeyDown={false}
                open={settingNumber.data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >

                <AppLogoLoading />
            </Dialog>
            {
                !settingNumber.data ?
                    <DeviceDependentSettingForm
                        formSettings={formSettings}
                        initialValues={settingNumber.initialValues}
                        handleSubmit={handleSubmit}
                        edit={true}
                        settingNumber={settingNumber}
                        setSettingNumber={setSettingNumber}
                        translations={translations}
                    /> : <CircularProgress
                        variant="determinate"
                        color="primary"
                        size={28}
                    />
            }
        </Paper>
    )
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        dependentSetting: state.admin.deviceDependentSettings.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onEditDeviceDependentSettings: deviceDependentSetting => dispatch(actions.editDependentSetting(deviceDependentSetting)),
        loadDependentSettings: deviceDependentSetting => dispatch(actions.loadDependentSetting(deviceDependentSetting)),
        clearForm: () => dispatch(actions.clearState())
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(DeviceDependentSettingsEdit));
